module.exports = __webpack_public_path__ + "img/light-mud-decal-14.18c8cf49.png";